module.exports = __webpack_public_path__ + "static/media/icon_oversized_garbage.7baf03c5.svg";